import { getDeviceInfo } from 'src/helper/webviewFun'

export const supportedLangs = ['ar', 'bn', 'en', 'fa', 'id', 'pt', 'ru', 'tr', 'ur', 'uz', 'zh']

export const getlang = async function (lang) {
  let res = await getDeviceInfo()
  lang = (res && res.res && res.res.language) || lang
  if (lang == '' || lang == undefined) {
    lang =
      navigator.language ||
      navigator.userLanguage ||
      navigator.browserLanguage ||
      navigator.systemLanguage // 常规浏览器语言和IE浏览器
  }
  lang = lang.substr(0, 2) // 截取lang前2位字符
  if (lang == 'ug') {
    lang = 'ar'
  }

  if (!supportedLangs.includes(lang)) {
    lang = 'en'
  }

  return lang || 'en'
}

export const setlang = function (language, lang) {
  // console.log('让我看看你是什么语言',language)
  switch (language) {
    case 'ar':
      return lang.ar || lang.en
    case 'bn':
      return lang.bn || lang.en
    case 'en':
      return lang.en
    case 'fa':
      return lang.fa || lang.en
    case 'id':
      return lang.id || lang.en
    case 'pt':
      return lang.pt || lang.en
    case 'ru':
      return lang.ru || lang.en
    case 'tr':
      return lang.tr || lang.en
    case 'ur':
      return lang.ur || lang.en
    case 'uz':
      return lang.uz || lang.en
    case 'zh':
      return lang.zh || lang.en
    default:
      return lang.en
  }
}

export const getlangV2 = async function (lang, langM) {
  let res = await getDeviceInfo()
  lang = (res && res.res && res.res.language) || lang

  if (!lang) {
    lang =
      navigator.language ||
      navigator.userLanguage ||
      navigator.browserLanguage ||
      navigator.systemLanguage
  }

  lang = lang.substr(0, 2)

  if (lang === 'ug') {
    lang = 'ar'
  }

  // const supportedLangs = ['zh', 'en', 'ar', 'tr', 'pt', 'id', 'ru', 'uz', 'fa', 'ur']

  if (!supportedLangs.includes(lang)) {
    lang = 'en'
  }

  // 如果 langM 不包含当前语言的键，则默认返回 'en'
  // 兼容旧环境的写法
  if (['ar', 'tr', 'pt', 'id', 'ru', 'uz', 'fa', 'ur'].includes(lang) && (!langM || !langM[lang])) {
    return 'en'
  }
  console.log('getlangV2', lang)
  return lang || 'en'
}



// WEBPACK FOOTER //
// src/helper/getlang.js